import { useAtomValue } from "jotai";
import { userAtom } from "../utils/store";
import { Navigate, useLocation } from "react-router-dom";

interface ComponentProp {
  children: JSX.Element;
}

const ProtectedRoute = ({ children }: ComponentProp) => {
  const user = useAtomValue(userAtom);

  const location = useLocation();

  return user?.Token ? (
    children
  ) : (
    <Navigate to="/" state={{ from: location }} replace={true} />
  );
};

export default ProtectedRoute;
